import React from 'react'
import { cn } from '../../lib/utils'

const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700",
      className
    )}
    {...props}
  >
    <div
      className="h-full bg-blue-600 dark:bg-blue-500 transition-all duration-300"
      style={{
        width: `${Math.min(Math.max(value, 0), 100)}%`,
      }}
    />
  </div>
))

Progress.displayName = "Progress"

export { Progress }
